import { MessageReplyTextIcon } from './MessageReplyTextIcon';

/**
 * author: Google
 * id FF34C5A8-4433-4B47-A9E5-EB836CFFCEC9
 * name message-reply-text
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-reply-text.svg
 * tags
 */
export const InsertCommentIcon = MessageReplyTextIcon;
export default InsertCommentIcon